import { MAX_MONTH_NUMBER, MIN_MONTH_NUMBER, SS_SWITCH_CONFIG } from 'social-security.module/common/domain/constants';

const DEFAULT_SWITCH_OPTION = SS_SWITCH_CONFIG[0].value;

class SocialSecuritySearchController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;

    this.maxMonthNumber = MAX_MONTH_NUMBER;
    this.minMonthNumber = MIN_MONTH_NUMBER;
    this.currentYear = new Date().getFullYear();
    this._initSwitch();
    this.initialSearch = true;
  }

  searchPeriod() {
    const searchCriteria = this._formatData();
    this.initialSearch = false;
    this.onSearch(this.EventEmitter({ data: searchCriteria }));
  }

  loadInitialData() {
    this.initialSearch = true;
    this._resetForm();
    this.onSearch();
  }

  _initSwitch() {
    this.switchOptions = SS_SWITCH_CONFIG;
    this.option = DEFAULT_SWITCH_OPTION;
  }

  _resetForm() {
    this.form.$setPristine();
    this.option = DEFAULT_SWITCH_OPTION;
    this.month = null;
    this.year = null;
  }

  _formatData() {
    const searchCriteria = {
      'month': this.month,
      'year' : this.year,
      'periodType': this.option
    };
    return searchCriteria;
  }

  getSwitchOption($event) {
    this.option = $event.option;
  }

  isDisabledButtonSearch() {
    return this.form.$invalid || this.form.month.$pristine || this.form.year.$pristine;
  }

  isDisabledButtonInitial() {
    return this.initialSearch;
  }

}

export default SocialSecuritySearchController;



// WEBPACK FOOTER //
// ./client/app/social-security.module/components/socialSecuritySearch/socialSecuritySearch.controller.js